import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  generalQuestions, 
  financeQuestions, 
  goalsQuestions, 
  familyQuestions, 
  healthQuestions, 
  securityQuestions, 
  analyticsQuestions 
} from '../data/faqData';

const FAQ: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      {/* Header */}
      <header style={{ 
        padding: '20px 40px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        background: 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(10px)'
      }}>
        <div 
          style={{ display: 'flex', alignItems: 'center', gap: '15px', cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          <span style={{ fontSize: '36px' }}>🎯</span>
          <h1 style={{ margin: 0, color: 'white', fontSize: '28px', fontWeight: 'bold' }}>AvatarMe</h1>
        </div>
        <div style={{ display: 'flex', gap: '25px', alignItems: 'center' }}>
          <button
            onClick={() => navigate('/faq')}
            style={{
              background: 'rgba(255,255,255,0.3)',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '8px',
              color: 'white',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            FAQ
          </button>
          <button
            onClick={() => navigate('/news')}
            style={{
              background: 'transparent',
              border: 'none',
              padding: '10px 20px',
              color: 'white',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Новости
          </button>
          <a
            href="https://t.me/FedorRubtsov"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '28px',
              textDecoration: 'none',
              transition: 'all 0.3s',
              display: 'flex',
              alignItems: 'center',
              filter: 'brightness(0) invert(1)'
            }}
            title="Связаться с основателем в Telegram"
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
            </svg>
          </a>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '12px 30px',
              background: 'rgba(255,255,255,0.2)',
              border: '2px solid white',
              borderRadius: '8px',
              color: 'white',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Войти
          </button>
        </div>
      </header>

      {/* Content */}
      <div style={{ 
        maxWidth: '1000px', 
        margin: '0 auto', 
        padding: '60px 40px',
        color: 'white'
      }}>
        <h2 style={{ 
          fontSize: '48px', 
          fontWeight: 'bold', 
          margin: '0 0 20px 0',
          textAlign: 'center'
        }}>
          ❓ Часто задаваемые вопросы
        </h2>
        <p style={{ 
          fontSize: '20px', 
          textAlign: 'center',
          opacity: 0.9,
          margin: '0 0 60px 0'
        }}>
          Всё, что нужно знать о возможностях AvatarMe
        </p>

        {/* Категории функционала */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
          {/* Общие вопросы */}
          <section>
            <h3 style={{ fontSize: '32px', marginBottom: '25px', fontWeight: 'bold' }}>🌟 Общие вопросы</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {generalQuestions.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    backdropFilter: 'blur(10px)',
                    padding: '25px 30px',
                    borderRadius: '12px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}
                >
                  <h4 style={{ fontSize: '20px', margin: '0 0 12px 0', fontWeight: 'bold' }}>{item.q}</h4>
                  <p style={{ fontSize: '16px', margin: 0, opacity: 0.9, lineHeight: '1.7' }}>{item.a}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Финансы */}
          <section>
            <h3 style={{ fontSize: '32px', marginBottom: '25px', fontWeight: 'bold' }}>💰 Финансы</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {financeQuestions.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    backdropFilter: 'blur(10px)',
                    padding: '25px 30px',
                    borderRadius: '12px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}
                >
                  <h4 style={{ fontSize: '20px', margin: '0 0 12px 0', fontWeight: 'bold' }}>{item.q}</h4>
                  <p style={{ fontSize: '16px', margin: 0, opacity: 0.9, lineHeight: '1.7' }}>{item.a}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Цели и задачи */}
          <section>
            <h3 style={{ fontSize: '32px', marginBottom: '25px', fontWeight: 'bold' }}>🎯 Цели и задачи</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {goalsQuestions.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    backdropFilter: 'blur(10px)',
                    padding: '25px 30px',
                    borderRadius: '12px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}
                >
                  <h4 style={{ fontSize: '20px', margin: '0 0 12px 0', fontWeight: 'bold' }}>{item.q}</h4>
                  <p style={{ fontSize: '16px', margin: 0, opacity: 0.9, lineHeight: '1.7' }}>{item.a}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Семья */}
          <section>
            <h3 style={{ fontSize: '32px', marginBottom: '25px', fontWeight: 'bold' }}>👨‍👩‍👧‍👦 Семья</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {familyQuestions.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    backdropFilter: 'blur(10px)',
                    padding: '25px 30px',
                    borderRadius: '12px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}
                >
                  <h4 style={{ fontSize: '20px', margin: '0 0 12px 0', fontWeight: 'bold' }}>{item.q}</h4>
                  <p style={{ fontSize: '16px', margin: 0, opacity: 0.9, lineHeight: '1.7' }}>{item.a}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Здоровье */}
          <section>
            <h3 style={{ fontSize: '32px', marginBottom: '25px', fontWeight: 'bold' }}>🏥 Здоровье</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {healthQuestions.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    backdropFilter: 'blur(10px)',
                    padding: '25px 30px',
                    borderRadius: '12px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}
                >
                  <h4 style={{ fontSize: '20px', margin: '0 0 12px 0', fontWeight: 'bold' }}>{item.q}</h4>
                  <p style={{ fontSize: '16px', margin: 0, opacity: 0.9, lineHeight: '1.7' }}>{item.a}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Безопасность */}
          <section>
            <h3 style={{ fontSize: '32px', marginBottom: '25px', fontWeight: 'bold' }}>🔒 Безопасность</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {securityQuestions.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    backdropFilter: 'blur(10px)',
                    padding: '25px 30px',
                    borderRadius: '12px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}
                >
                  <h4 style={{ fontSize: '20px', margin: '0 0 12px 0', fontWeight: 'bold' }}>{item.q}</h4>
                  <p style={{ fontSize: '16px', margin: 0, opacity: 0.9, lineHeight: '1.7' }}>{item.a}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Аналитика */}
          <section>
            <h3 style={{ fontSize: '32px', marginBottom: '25px', fontWeight: 'bold' }}>📊 Аналитика</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {analyticsQuestions.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    backdropFilter: 'blur(10px)',
                    padding: '25px 30px',
                    borderRadius: '12px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}
                >
                  <h4 style={{ fontSize: '20px', margin: '0 0 12px 0', fontWeight: 'bold' }}>{item.q}</h4>
                  <p style={{ fontSize: '16px', margin: 0, opacity: 0.9, lineHeight: '1.7' }}>{item.a}</p>
                </div>
              ))}
            </div>
          </section>
        </div>

        {/* CTA */}
        <div style={{
          marginTop: '80px',
          padding: '50px 40px',
          background: 'rgba(255,255,255,0.15)',
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
          textAlign: 'center',
          border: '1px solid rgba(255,255,255,0.2)'
        }}>
          <h3 style={{ fontSize: '32px', margin: '0 0 15px 0', fontWeight: 'bold' }}>
            Не нашли ответ на свой вопрос?
          </h3>
          <p style={{ fontSize: '18px', margin: '0 0 25px 0', opacity: 0.9 }}>
            Свяжитесь с нами в Telegram — мы всегда рады помочь!
          </p>
          <a
            href="https://t.me/FedorRubtsov"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '16px 40px',
              background: '#0088cc',
              border: 'none',
              borderRadius: '10px',
              color: 'white',
              fontSize: '18px',
              fontWeight: 'bold',
              textDecoration: 'none',
              boxShadow: '0 6px 25px rgba(0,0,0,0.3)',
              transition: 'all 0.3s'
            }}
          >
            Написать в Telegram
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
